import React from "react";
import { useHistory } from "react-router-dom";
export default function Page404() {
  const history = useHistory();
  function goHome() {
    history.push("/");
  }
  return (
    <div>
      <div className="hit-the-floor">404</div>
      <div className="container center">
        <div className="">Not found!</div>
        <button onClick={goHome} className="btn btn-primary btn-sm">
          Home
        </button>
      </div>
    </div>
  );
}
